import { makeStyles } from '@material-ui/core/styles'
import { theme } from 'config/constants/theme/theme'

export default makeStyles({
  becomeExpertIn: {
    height: '38px',
    width: '417px',
    color: '#225190',
    fontSize: '38px',
    fontWeight: 300,
    lineHeight: '38px',
    [theme.breakpoints.down('sm')]: {
      fontSize: 24
    }
  },
  title: {
    color: '#225190',
    fontSize: 18,
    fontWeight: 500,
    letterSpacing: '0.04em'
  }
})
